/** @format */

import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import CardWrap from "../Common/CardWrap";
import StoreDetailTab from "../Tab/StoreDetailTab";
import SpinnerLoading from "../../Components/Common/SpinnerLoading";
import * as dateHelper from "../../Helpers/DateHelper";
import { posServices, storeService, globalServices } from "../../Services";
import { useTranslation } from "react-i18next";
import ItemsTab from "../Tab/ItemsTab";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { AuthContext } from "../../Contexts/AuthContext";
import { Tabs, Tab, Modal, Dropdown, Button } from "react-bootstrap";
import { roles } from "../../Config/Roles";
import DeactivatePos from "./DeactivatePos";
import ChangePos from "./ChangePos";
import SwitchPos from "./SwitchPos";
import ActivatePosModal from "./ActivatePosModal";
import ResultModal from "../Common/ResultModal";
import SuspensionPosModal from "./SuspensionPosModal";
import UnInstallPosModal from "./UnInstallPosModal";
import UnSuspendPosModal from "./UnSuspendPosModal";
import ChangeBillNumber from "./ChangeBillNumber";
import ChangePosTagModal from "./ChangePosTagModal";
import { ictNumber } from "../../Config/Regex";
import SendMessageModal from "./SendMessageModal";
import { useForm } from "react-hook-form";
import "./PosDetail.css";
import ChangePosVersionModal from "./ChangePosVersionModal";
import VersionHistoryTab from "../Tab/VersionHistoryTab";
import SyncLogModal from "./SyncLogModal";
import SyncInvoicesModal from "./SyncInvoicesModal";
import ClearDataModal from "./ClearDataModal";

const PosDetail = ({ match }) => {
  const { t: translator } = useTranslation();
  const posId = match.params.posId;
  const history = useHistory();
  const { register, handleSubmit, errors } = useForm();
  const {
    locTab,
    updateLocName,
    updateLocPos,
    updateLocTenant,
    updateLocStore,
    updateLocTab,
    updateLocKey,
  } = useContext(GlobalContext);
  const { roleId } = useContext(AuthContext);
  const [key, setKey] = useState(locTab);
  const [isPosDetailLoading, setIsPosDetailLoading] = useState(true);
  const { cashier, accountant, manager, master, admin, support } = roles;
  const [pos, setPos] = useState();
  const [newVersion, setNewVersion] = useState(false);
  const [store, setStore] = useState();
  const [update, setUpdate] = useState(new Date());
  const [showDeactivation, setShowDeactivation] = useState(false);
  const [showActivation, setShowActivation] = useState(false);
  const [showSyncLog, setShowSyncLog] = useState(false);
  const [showSyncInvoices, setShowSyncInvoices] = useState(false);
  const [showClearData, setShowClearData] = useState(false);
  const [showChange, setShowChange] = useState(false);
  const [changeVersionModal, setChangeVersionModal] = useState(false);
  const [showChangeBillNumber, setShowChangeBillNumber] = useState(false);
  const [showChangePosTag, setShowChangePosTag] = useState(false);
  const [showSendMessageModal, setShowSendMessageModal] = useState(false);
  const [showSwitch, setShowSwitch] = useState(false);
  const [showSuspension, setShowSuspension] = useState(false);

  const [showUnInstall, setShowUnInstall] = useState(false);
  const [showUnSuspension, setShowUnSuspension] = useState(false);
  const [POSsettings, setPOSSettings] = useState({
    OverviewCertificate: true,
    OverviewDocumentNumber: true,
    OverviewPos: true,
    OverviewStore: true,
    OverviewTenant: true,
    OverviewUsers: true,
  });

  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
    success: true,
  });

  useEffect(() => {
    updateLocPos(posId);
    updateLocKey(posId);
    if (posId) {
      posServices
        .getById(posId)
        .then((res) => {
          setPos(res.data);
          res.data.posVersion?.startsWith("3") && setNewVersion(true);

          setIsPosDetailLoading(false);
        })
        .catch((err) => console.log(err));
    }

    if (locTab != null && locTab != 0) {
      setKey(locTab);
    } else {
      setKey("products");
      updateLocTab("products");
    }
  }, [posId, update]);

  useEffect(() => {
    if (pos) {
      updateLocName("pos");
      updateLocTenant(pos.tenantId);
      updateLocStore(pos.storeId);
      updateLocPos(posId);

      globalServices
        .Overview(pos.storeId, posId)
        .then((res) => {
          setPOSSettings(res.data.data);
        })
        .catch((err) => console.log(err));

      storeService.getById(pos.storeId).then((res) => {
        setStore(res.data);
      });
    }
  }, [pos, update]);

  const handleCancel = () => {
    history.push("/pos");
  };

  const handleClose = () => {
    setModal({ show: false });
  };

  const confirmActivation = () => {
    setShowActivation(false);
    posServices
      .reactivatePos(posId)
      .then((res) => {
        res.data.success
          ? setModal({
              show: true,
              title: translator("ReactivatePos-SuccessModal-Title"),
              text: translator("ReactivatePos-SuccessModal-Text"),
              btnClass: "btn btn-primary",
              success: true,
            })
          : setModal({
              show: true,
              title: translator("ReactivatePos-UnsuccessModal-Title"),
              text: translator("ReactivatePos-UnsuccessModal-Text"),
              btnClass: "btn btn-primary",
              success: false,
            });
        setUpdate(new Date());
      })
      .catch((err) => console.log(err));
  };
  const syncLog = () => {
    setShowSyncLog(false);
    posServices
      .syncLog(posId)
      .then((res) => {
        res.data.success
          ? setModal({
              show: true,
              title: translator("SyncLogPos-SuccessModal-Title"),
              text: translator("SyncLogPos-SuccessModal-Text"),
              btnClass: "btn btn-primary",
              success: true,
            })
          : setModal({
              show: true,
              title: translator("SyncLogPos-UnsuccessModal-Title"),
              text: translator("SyncLogPos-UnsuccessModal-Text"),
              btnClass: "btn btn-primary",
              success: false,
            });
      })
      .catch((err) => console.log(err));
  };
  const syncInvoices = () => {
    setShowSyncInvoices(false);
    posServices
      .syncInvoices(posId)
      .then((res) => {
        res.data.success
          ? setModal({
              show: true,
              title: translator("SyncInvoicesPos-SuccessModal-Title"),
              text: translator("SyncInvoicesPos-SuccessModal-Text"),
              btnClass: "btn btn-primary",
              success: true,
            })
          : setModal({
              show: true,
              title: translator("SyncInvoicesPos-UnsuccessModal-Title"),
              text: translator("SyncInvoicesPos-UnsuccessModal-Text"),
              btnClass: "btn btn-primary",
              success: false,
            });
      })
      .catch((err) => console.log(err));
  };
  const clearData = () => {
    setShowClearData(false);
    posServices
      .clearData(posId)
      .then((res) => {
        res.data.success
          ? setModal({
              show: true,
              title: translator("SyncLogPos-SuccessModal-Title"),
              text: translator("SyncLogPos-SuccessModal-Text"),
              btnClass: "btn btn-primary",
              success: true,
            })
          : setModal({
              show: true,
              title: translator("SyncLogPos-UnsuccessModal-Title"),
              text: translator("SyncLogPos-UnsuccessModal-Text"),
              btnClass: "btn btn-primary",
              success: false,
            });
      })
      .catch((err) => console.log(err));
  };

  const confirmUnSuspension = () => {
    setShowUnSuspension(false);
    posServices
      .unsuspendPos(posId)
      .then((res) => {
        res.data.success
          ? setModal({
              show: true,
              title: translator("PosDetail-UnSuspendPos"),
              text: translator("UnSuspendPos-SuccessModal-Text"),
              btnClass: "btn btn-primary",
              success: true,
            })
          : setModal({
              show: true,
              title: translator("PosDetail-UnSuspendPos"),
              text: translator("UnSuspendPos-UnsuccessModal-Text"),
              btnClass: "btn btn-primary",
              success: false,
            });
        setUpdate(new Date());
      })
      .catch((err) => console.log(err));
  };
  const updatePos = () => {
    history.push(`/edit-pos/${posId}`);
  };

  function currencyFormatter(cell) {
    return new Intl.NumberFormat("hr", {
      style: "currency",
      currency: "EUR",
    }).format(Number(cell));
  }

  return (
    <>
      <CardWrap subtitle={translator("POS-POSDetails-Subtitle")}>
        <div className="row pl-0">
          <div className="col-lg-3">
            <div className="custom-card m-2">
              {isPosDetailLoading && <SpinnerLoading />}
              {!isPosDetailLoading && pos && (
                <>
                  <div className="custom-card-header">
                    <h3>
                      {translator("ICT-number")}: {pos.inventoryNumber}{" "}
                      {![cashier, accountant, manager].includes(
                        Number(roleId)
                      ) && (
                        <span className="button-edit">
                          {" "}
                          <span
                            onClick={updatePos}
                            title={translator("PosDetail-EditIcon-Title")}
                            className="icon icon-edit"
                          ></span>
                        </span>
                      )}
                    </h3>
                    <span className="custom-card-subtitle">
                      <strong>{translator("Pos-PosDetail-Msisdn")}:</strong>{" "}
                      {pos.msisdn}
                    </span>
                    <hr />
                  </div>
                  <div className="custom-card-body">
                    <span>
                      <strong>{translator("Pos-PosDetail-Tid")}:</strong>{" "}
                      {pos.tid}
                    </span>
                    <br />
                    <strong>{translator("POS-POSDetails-Tag")}:</strong>
                    {pos.tag}
                    <br />
                    <span>
                      <strong>
                        {translator("POS-POSDetails-POSSerialNumber")}:
                      </strong>{" "}
                      {pos.posserialNumber}
                    </span>
                    <br />
                    <span>
                      <strong>{translator("POS-POSDetails-Deposit")}:</strong>{" "}
                      {currencyFormatter(pos.deposit)}
                    </span>
                    <br />
                    <span>
                      <strong>
                        {translator("POS-POSDetails-POSVersion")}:
                      </strong>{" "}
                      {pos.posVersion}
                    </span>
                    <hr />
                    <label className="labelCont">
                      <input
                        type="checkbox"
                        name="fiscalObligation"
                        checked={pos.workingMode}
                      />
                      <span className="checkmark"></span>
                    </label>
                    <span className="Data">
                      {translator("PosDetail-WorkingMode")}
                    </span>
                    <br />
                    <label className="labelCont">
                      <input
                        type="checkbox"
                        name="fiscalObligation"
                        checked={pos.closeArticleSearch}
                      />
                      <span className="checkmark"></span>
                    </label>
                    <span className="Data">
                      {translator("PosDetail-ItemSearch")}
                    </span>
                    <br />
                    <label className="labelCont">
                      <input
                        type="checkbox"
                        name="fiscalObligation"
                        checked={pos.multiDraft}
                      />
                      <span className="checkmark"></span>
                    </label>
                    <span className="Data">
                      {translator("PosDetail-MoreDraft")}
                    </span>
                    <br />
                    <label className="labelCont">
                      <input
                        type="checkbox"
                        name="fiscalObligation"
                        checked={pos.cashDefault}
                      />
                      <span className="checkmark"></span>
                    </label>
                    <span className="Data">
                      {translator("PosDetail-CashDefault")}
                    </span>
                    <hr />
                    {[master, admin, support].includes(Number(roleId)) && (
                      <>
                        <span>
                          <strong>{translator("ActivationCode")}:</strong>{" "}
                          {pos.activationCode}
                        </span>
                        <br />
                      </>
                    )}
                     {[master, admin, support].includes(Number(roleId)) && newVersion && (
                      <>
                        <span>
                          <strong>{translator("FcmToken")}:</strong>{" "}
                          {pos.fcmToken}
                        </span>
                        <br />
                      </>
                    )}
                    <span>
                      <strong>
                        {translator("POS-POSDetails-ActivationDate")}:
                      </strong>{" "}
                      {pos.activationDate
                        ? dateHelper.formatUtcToDate(pos.activationDate)
                        : translator("Pos-NotActivated")}
                    </span>
                    <br />
                    <span>
                      <strong>{translator("POS-POSDetails-ValidFrom")}:</strong>{" "}
                      {pos.subscriptionValidFrom &&
                        dateHelper.formatUtcToDate(pos.subscriptionValidFrom)}
                    </span>
                    <br />
                    <span>
                      <strong>{translator("POS-POSDetails-LastSync")}:</strong>{" "}
                      {pos.lastSyncTime &&
                        dateHelper.formatUtcToDate(pos.lastSyncTime)}
                    </span>
                    <br />
                    <br />
                    {[master].includes(Number(roleId)) && newVersion && (
                      <>
                        <button
                          className="btn btn-outline-secondary btn-block"
                          type="button"
                          onClick={() => setShowSendMessageModal(true)}
                        >
                          {translator("PosDetail-SendMessage")}
                        </button>
                        <button
                          className="btn btn-outline-secondary btn-block"
                          type="button"
                          onClick={() => setShowSyncLog(true)}
                        >
                          {translator("PosDetail-SyncLog")}
                        </button>
                        <button
                          className="btn btn-outline-secondary btn-block"
                          type="button"
                          onClick={() => setShowSyncInvoices(true)}
                        >
                          {translator("PosDetail-SyncInvoices")}
                        </button>
                         <button
                          className="btn btn-outline-secondary btn-block"
                          type="button"
                          onClick={() => setShowClearData(true)}
                        >
                          {translator("PosDetail-ClearData")}
                        </button>
                      </>
                    )}
                    <br />
                    
                  </div>
                  {[master, admin, support].includes(Number(roleId)) && (
                    <div
                      className="custom-card-footer row"
                      style={{
                        borderTop: "1px solid #ccc",
                        paddingTop: "22px",
                      }}
                    >
                      <label className="control-label col-md-12">
                        * {translator("DangerArea")}
                      </label>
                      {!pos.isUninstalled ? (
                        <>
                          {" "}
                          <div
                            className={
                              pos.isSuspended && !pos.isActive
                                ? "allHidden"
                                : "col-md-12 mb-3"
                            }
                          >
                            <button
                              className="btn btn-outline-secondary btn-block"
                              type="button"
                              onClick={() => setShowChangeBillNumber(true)}
                            >
                              {translator("PosDetail-ChangeBillNumber")}
                            </button>
                          </div>
                          <div
                            className={
                              pos.isSuspended && !pos.isActive
                                ? "allHidden"
                                : "col-md-12 mb-3"
                            }
                          >
                            <button
                              className="btn btn-outline-secondary btn-block"
                              type="button"
                              onClick={() => setShowChangePosTag(true)}
                            >
                              {translator("PosDetail-ChangePosTag")}
                            </button>
                          </div>
                          <div
                            className={
                              pos.isSuspended && !pos.isActive
                                ? "allHidden"
                                : "col-md-12 mb-3"
                            }
                          >
                            <button
                              className="btn btn-outline-secondary btn-block"
                              type="button"
                              onClick={() => setChangeVersionModal(true)}
                            >
                              {translator("PosDetail-ChangeVersion")}
                            </button>
                          </div>
                          <div
                            className={
                              pos.isSuspended ? "allHidden" : "col-md-6"
                            }
                          >
                            <button
                              className="btn btn-outline-secondary btn-block"
                              type="button"
                              onClick={() => setShowChange(true)}
                            >
                              {translator("PosDetail-Change")}
                            </button>
                          </div>
                          <div
                            className={
                              pos.isSuspended ? "allHidden" : "col-md-6"
                            }
                          >
                            <button
                              className="btn btn-outline-secondary btn-block"
                              type="button"
                              onClick={() => setShowSwitch(true)}
                            >
                              {translator("PosDetail-SwitchPos")}
                            </button>
                          </div>
                        </>
                      ) : (
                        ""
                      )}

                      {!pos.isUninstalled ? (
                        <div
                          className={
                            pos.isUninstalled ? "allHidden" : "col-md-12 mt-3"
                          }
                        >
                          <button
                            className="btn btn-danger btn-block"
                            type="button"
                            onClick={() => setShowUnInstall(true)}
                          >
                            {translator("PosDetail-UnInstall")}
                          </button>
                        </div>
                      ) : (
                        <>
                          <div
                            className={
                              !pos.isUninstalled ? "allHidden" : "col-md-12 mt-3"
                            }
                          >
                            <strong className="text-danger">
                              {translator("POS-UnistalledPosNotice")}
                            </strong>
                          </div>
                        </>
                      )}
                      {pos.isSuspended && !pos.isUninstalled ? (
                        <>
                          <div className="col-md-12 mt-3">
                            <button
                              className="btn btn-danger btn-block"
                              type="button"
                              onClick={() => setShowUnSuspension(true)}
                            >
                              {translator("PosDetail-UnSuspendPos")}
                            </button>
                          </div>
                          <div className="control-label col-md-12 ">
                            {translator("PosLogReason-SuspendReason")}: &nbsp;
                            <span>{pos.suspensionNote}</span>
                          </div>
                        </>
                      ) : (
                        !pos.isUninstalled ? (
                        <>
                          <div className="col-md-12 mt-3">
                            <button
                              className="btn btn-danger btn-block"
                              type="button"
                              onClick={() => setShowSuspension(true)}
                            >
                              {translator("PosDetail-SuspendPos")}
                            </button>
                          </div>
                        </>): (null)
                      )}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
          <div className="col-lg-9 border-left">
            <Tabs
              id="controlled-tab-example"
              activeKey={key}
              onSelect={(k) => {
                setKey(k);
                updateLocTab(k);
              }}
            >
              <Tab
                eventKey="products"
                title={translator("POS-POSDetails-ListPrice")}
                tabClassName="mob-tabs"
              >
                {store && store.priceListId && (
                  <ItemsTab
                    priceListId={store.priceListId}
                    tenantId={store.tenantId}
                    storeId={store.storeId}
                  />
                )}
              </Tab>
              <Tab
                eventKey="stores"
                title={translator("POS-POSDetails-Store")}
                tabClassName="mob-tabs"
              >
                {pos && <StoreDetailTab storeId={pos.storeId} />}
              </Tab>

              <Tab
                eventKey="overview"
                title={translator("POS-SettingsTab")}
                tabClassName="mob-tabs"
              >
                <div style={{ marginTop: "20px" }} className="col-lg-6">
                  {POSsettings.OverviewTenant === true ? (
                    <>
                      <span
                        style={{ color: "green", fontSize: "23px" }}
                        className="icon-available_solid"
                      ></span>{" "}
                      <strong className="overviewName">
                        {translator("OverviewTenant")}
                      </strong>
                      <br />
                      <span>
                        <span className="icon icon-information"></span>{" "}
                        {translator("OverviewTenant-Hint")}
                      </span>
                    </>
                  ) : (
                    <>
                      <span
                        style={{
                          color: "#eb2f21",
                          fontSize: "23px",
                        }}
                        className="icon-cancel"
                      ></span>{" "}
                      <strong className="overviewName">
                        {translator("OverviewTenant")}
                      </strong>
                      <br />
                      <span>
                        <span className="icon icon-information"></span>{" "}
                        {translator("OverviewTenant-Hint")}
                      </span>
                    </>
                  )}
                  <hr />
                  {POSsettings.OverviewCertificate === true ? (
                    <>
                      <span
                        style={{ color: "green", fontSize: "23px" }}
                        className="icon-available_solid"
                      ></span>{" "}
                      <strong className="overviewName">
                        {translator("OverviewCertificate")}
                      </strong>
                      <br />
                      <span>
                        <span className="icon icon-information"></span>{" "}
                        {translator("OverviewCertificate-Hint")}
                      </span>
                    </>
                  ) : (
                    <>
                      <span
                        style={{
                          color: "#eb2f21",
                          fontSize: "23px",
                        }}
                        className="icon-cancel"
                      ></span>{" "}
                      <strong className="overviewName">
                        {translator("OverviewCertificate")}
                      </strong>
                      <br />
                      <span>
                        <span className="icon icon-information"></span>{" "}
                        {translator("OverviewCertificate-Hint")}
                      </span>
                    </>
                  )}
                  <hr />
                  {POSsettings.OverviewDocumentNumber === true ? (
                    <>
                      <span
                        style={{ color: "green", fontSize: "23px" }}
                        className="icon-available_solid"
                      ></span>{" "}
                      <strong className="overviewName">
                        {translator("OverviewDocumentNumber")}
                      </strong>
                      <br />
                      <span>
                        <span className="icon icon-information"></span>{" "}
                        {translator("OverviewDocumentNumber-Hint")}
                      </span>
                    </>
                  ) : (
                    <>
                      <span
                        style={{
                          color: "#eb2f21",
                          fontSize: "23px",
                        }}
                        className="icon-cancel"
                      ></span>{" "}
                      <strong className="overviewName">
                        {translator("OverviewDocumentNumber")}
                      </strong>
                      <br />
                      <span>
                        <span className="icon icon-information"></span>{" "}
                        {translator("OverviewDocumentNumber-Hint")}
                      </span>
                    </>
                  )}
                  <hr />
                  {POSsettings.OverviewPos === true ? (
                    <>
                      <span
                        style={{ color: "green", fontSize: "23px" }}
                        className="icon-available_solid"
                      ></span>{" "}
                      <strong className="overviewName">
                        {translator("OverviewPos")}
                      </strong>
                      <br />
                      <span>
                        <span className="icon icon-information"></span>{" "}
                        {translator("OverviewPos-Hint")}
                      </span>
                    </>
                  ) : (
                    <>
                      <span
                        style={{
                          color: "#eb2f21",
                          fontSize: "23px",
                        }}
                        className="icon-cancel"
                      ></span>{" "}
                      <strong className="overviewName">
                        {translator("OverviewPos")}
                      </strong>
                      <br />
                      <span>
                        <span className="icon icon-information"></span>{" "}
                        {translator("OverviewPos-Hint")}
                      </span>
                    </>
                  )}
                  <hr />
                  {POSsettings.OverviewStore === true ? (
                    <>
                      <span
                        style={{ color: "green", fontSize: "23px" }}
                        className="icon-available_solid"
                      ></span>{" "}
                      <strong className="overviewName">
                        {translator("OverviewStore")}
                      </strong>{" "}
                      <br />
                      <span>
                        <span className="icon icon-information"></span>{" "}
                        {translator("OverviewStore-Hint")}
                      </span>
                    </>
                  ) : (
                    <>
                      <span
                        style={{
                          color: "#eb2f21",
                          fontSize: "23px",
                        }}
                        className="icon-cancel"
                      ></span>{" "}
                      <strong className="overviewName">
                        {translator("OverviewStore")}
                      </strong>{" "}
                      <br />
                      <span>
                        <span className="icon icon-information"></span>{" "}
                        {translator("OverviewStore-Hint")}
                      </span>
                    </>
                  )}
                  <hr />
                  {POSsettings.OverviewUsers === true ? (
                    <>
                      <span
                        style={{ color: "green", fontSize: "23px" }}
                        className="icon-available_solid"
                      ></span>{" "}
                      <strong className="overviewName">
                        {translator("OverviewUsers")}
                      </strong>
                      <br />
                      <span>
                        <span className="icon icon-information"></span>{" "}
                        {translator("OverviewUsers-Hint")}
                      </span>
                    </>
                  ) : (
                    <>
                      <span
                        style={{
                          color: "#eb2f21",
                          fontSize: "23px",
                        }}
                        className="icon-cancel"
                      ></span>{" "}
                      <strong className="overviewName">
                        {translator("OverviewUsers")}
                      </strong>
                      <br />
                      <span>
                        <span className="icon icon-information"></span>{" "}
                        {translator("OverviewUsers-Hint")}
                      </span>
                    </>
                  )}
                </div>
              </Tab>
              <Tab
                eventKey="version"
                title={translator("POS-POSDetails-VersionHistory")}
                tabClassName="mob-tabs"
              >
                {pos && <VersionHistoryTab posId={posId} />}
              </Tab>
            </Tabs>
          </div>
        </div>
        <div
          className="container-fluid"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <button className="btn btn-outline-secondary" onClick={handleCancel}>
            {translator("POS-POSDetails-BtnBack")}
          </button>
        </div>
      </CardWrap>
      <DeactivatePos
        posId={posId}
        show={showDeactivation}
        handleHide={() => {
          setUpdate(new Date());
          setShowDeactivation(false);
        }}
      />
      <SuspensionPosModal
        posId={posId}
        show={showSuspension}
        handleHide={() => {
          setUpdate(new Date());
          setShowSuspension(false);
        }}
      />

      <UnInstallPosModal
        posId={posId}
        show={showUnInstall}
        handleHide={() => {
          setUpdate(new Date());
          setShowUnInstall(false);
        }}
      />
      <UnSuspendPosModal
        show={showUnSuspension}
        handleHide={() => {
          setUpdate(new Date());
          setShowUnSuspension(false);
        }}
        title={translator("PosDetail-UnSuspendPos")}
        text={translator("PosDetail-UnSuspendPos-Text")}
        confirmUnSuspension={confirmUnSuspension}
      />
      <ActivatePosModal
        show={showActivation}
        handleHide={() => {
          setUpdate(new Date());
          setShowActivation(false);
        }}
        title={translator("POS-ActivationModal-Title")}
        text={translator("POS-ActivationModal-Text")}
        confirmActivation={confirmActivation}
      />      
      <SyncLogModal
        show={showSyncLog}
        handleHide={() => {
          setUpdate(new Date());
          setShowSyncLog(false);
        }}
        title={translator("POS-SyncLog-Title")}
        text={translator("POS-SyncLog-Text")}
        syncLog={syncLog}
      />
      <SyncInvoicesModal
        show={showSyncInvoices}
        handleHide={() => {
          setUpdate(new Date());
          setShowSyncInvoices(false);
        }}
        title={translator("POS-SyncInvoices-Title")}
        text={translator("POS-SyncInvoices-Text")}
        syncInvoices={syncInvoices}
      />
      <ClearDataModal
        show={showClearData}
        handleHide={() => {
          setUpdate(new Date());
          setShowClearData(false);
        }}
        title={translator("POS-ClearData-Title")}
        text={translator("POS-ClearData-Text")}
        clearData={clearData}
      />
      <SwitchPos
        posId={posId}
        tenantId={pos && pos.tenantId}
        show={showSwitch}
        tag={pos && pos.tag}
        documentNumber={pos && pos.documentNumber}
        handleHide={() => {
          setUpdate(new Date());
          setShowSwitch(false);
        }}
      />
      {pos != undefined && (
        <ChangePos
          posId={posId}
          //posserialNumber={pos.posserialNumber}
          //inventoryNumber={pos.inventoryNumber}
          //tid={pos.tid}
          //msisdn={pos.msisdn}
          //generateNewActivationCode={true}
          defaultValues={{
            ictNumber: pos.inventoryNumber,
            posserialNumber: pos.posserialNumber,
            msisdn: pos.msisdn,
          }}
          show={showChange}
          handleHide={() => {
            setUpdate(new Date());
            setShowChange(false);
          }}
        />
      )}

      <ChangeBillNumber
        posId={posId}
        show={showChangeBillNumber}
        handleHide={() => {
          setUpdate(new Date());
          setShowChangeBillNumber(false);
        }}
      />

      <ChangePosTagModal
        posId={posId}
        show={showChangePosTag}
        handleHide={() => {
          setUpdate(new Date());
          setShowChangePosTag(false);
        }}
      />

      <SendMessageModal
        posId={posId}
        tenantId={pos && pos.tenantId}
        show={showSendMessageModal}
        handleHide={() => {
          setUpdate(new Date());
          setShowSendMessageModal(false);
        }}
      />

      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />
      <ChangePosVersionModal
        changeVersionModal={changeVersionModal}
        setChangeVersionModal={setChangeVersionModal}
        pos={pos}
        posId={posId}
      />
    </>
  );
};

export default PosDetail;
